module.exports = __webpack_public_path__ + "static/media/lek.db9a72e9.svg";